/* 馬超傳・第 1 章：平陽（202 年）
 * 汾水由北往南流過地圖中央，中間一處渡口可以涉水。西岸是鍾繇、馬超的營，東岸是郭援、高幹的袁軍；平陽城在西北。 */
export const FORD = [3560, 2200], CAMP = [900, 2200], YUAN = [6300, 2200], PINGYANG = [1700, 800];
export default {
  id: 'machao_pingyang', name: '平陽・汾水', W: 7200, H: 4400, seed: 202,
  bases: [CAMP, YUAN],
  rivers: [{ pts: [[3500, -100], [3700, 1200], [3550, 2200], [3700, 3300], [3600, 4500]], hw: 220, fords: [[3560, 2200, 280]] }],
  roads: [{ pts: [CAMP, [2200, 2250], [3200, 2200]], w: 140 }, { pts: [[3950, 2200], [5000, 2150], YUAN], w: 140 }, { pts: [CAMP, PINGYANG], w: 110 }],
  rocks: [[2200, 3600, 420, 200], [5200, 3700, 400, 190], [5400, 900, 400, 180], [2500, 1100, 300, 150]],
  woods: 0.35,
  sight: 0.85,
  clearings: [[CAMP[0], CAMP[1], 550], [2900, 2200, 450], [4200, 2200, 450], [YUAN[0], YUAN[1], 550], [PINGYANG[0], PINGYANG[1], 400]],
  marsh: [[3150, 2600, 200, 90], [3950, 1800, 200, 90]],
  villages: [{ x: PINGYANG[0], y: PINGYANG[1], n: 7, r: 360 }],
  tents: [{ x: CAMP[0], y: CAMP[1], n: 6, r: 380, chief: true, col: '#5a6a3a', flag: '鍾' }, { x: YUAN[0], y: YUAN[1], n: 7, r: 400, chief: true, col: '#7a5a2a', flag: '袁' }],
  grass: [[2800, 1700, 220, 100], [2800, 2750, 220, 100]],
};
